/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': 'Chatoptionen für {conversationName}',
  'ai-mate.all-chat-view.chat-item.delete-label': 'Löschen',
  'ai-mate.all-chat-view.chat-item.rename-label': 'Umbenennen',
  'ai-mate.all-chat-view.new-chat-button-label': 'Neuer Chat',
  'ai-mate.chat-error-banner.description': 'Ihr Chatverlauf wird bis zu 30 Tage gespeichert.',
  'ai-mate.chat-error-banner.title': 'Neuen Chat beginnen',
  'ai-mate.chat-error.description': 'Versuchen Sie, den <btn>Chat neu zu laden</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Sie haben die maximale Anzahl Anfragen erreicht. Bitte versuchen Sie es später erneut.',
  'ai-mate.chat-error.rate-limited-title': 'Zu viele Anfragen',
  'ai-mate.chat-error.rovo-inactive-description':
    'Rovo ist auf Ihrer Site scheinbar noch nicht aktiviert. <link>Rovo einrichten</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo ist inaktiv',
  'ai-mate.chat-error.title': 'Wir sind nicht sicher, was schiefgelaufen ist.',
  'ai-mate.chat-history.loading-state.collapse-icon': 'Reduzieren',
  'ai-mate.chat-history.loading-state.expand-icon': 'Erweitern',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': 'Rovo überlegt',
  'ai-mate.chat-input.file-close-icon-label': 'Datei entfernen',
  'ai-mate.chat-input.file-error-icon-label': 'Fehler beim Laden der Datei',
  'ai-mate.chat-input.store-user-messages.label':
    'Diese Nachricht aufnehmen, um uns dabei zu helfen, die Antwortqualität zu verbessern',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Löschen',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Chatoptionen für {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Umbenennen',
  'ai-mate.common.ui.expandable-section.collapse': 'Reduzieren',
  'ai-mate.common.ui.expandable-section.expand': 'Erweitern',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Seiten auswählen',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'Bereich auswählen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Abbrechen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Die Unterhaltung, die Sie löschen möchten, existiert nicht.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Löschen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Unterhaltung "{name}" löschen?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Beim Löschen der Unterhaltung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Möchten Sie diese Unterhaltung wirklich löschen? Der Vorgang kann nicht rückgängig gemacht werden.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Abbrechen',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Der Kanal, den Sie bearbeiten möchten, existiert nicht.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Name',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Beim Bearbeiten der Unterhaltung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Unterhaltung bearbeiten',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Der Name entspricht dem aktuellen Namen.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Speichern',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} Ergebnis gefunden} other {{results,number} Ergebnisse gefunden}}',
  'ai-mate.conversation-list-view.back-button.label': 'Zurück',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Chat schließen',
  'ai-mate.conversation-list-view.header-title': 'Chatverlauf',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Neuer Chat',
  'ai-mate.conversation-list-view.no-chat': 'Keine Ergebnisse',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Chats durchsuchen',
  'ai-mate.expander.hide-details': 'Details ausblenden',
  'ai-mate.expander.show-details': 'Mehr Details anzeigen',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Chat schließen',
  'ai-mate.main-chat.hamburger-menu-label': 'Menü',
  'ai-mate.main-chat.maximize-chat-button-label': 'Vollbild',
  'ai-mate.main-chat.minimize-chat-button-label': 'Ansicht wiederherstellen',
  'ai-mate.main-chat.new-chat-button-label': 'Neu',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Neuer Chat',
  'ai-mate.rovo-chat-header.back-home-button-label': 'Zurück zur Startseite',
  'ai-mate.rovo-chat-header.chrome-extension-button-text': 'Chrome-Erweiterung',
  'ai-mate.rovo-chat-header.chrome-extension-icon-label': 'Chrome-Erweiterung',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Schließen',
  'ai-mate.rovo-chat-header.debug-button-label': 'Fehlersuche',
  'ai-mate.rovo-chat-header.debug-icon-label': 'Fehlersuche',
  'ai-mate.rovo-chat-header.delete-button-text': 'Löschen',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Löschen',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Feedback',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Feedback',
  'ai-mate.rovo-chat-header.floating-button-text': 'Nicht verankert',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Nicht verankert',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Vollbild',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Vollbild',
  'ai-mate.rovo-chat-header.get-help-button-text': 'Hilfe erhalten',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'Hilfe erhalten',
  'ai-mate.rovo-chat-header.menu-button-label': 'Menü',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'Mehr',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'Neuer Chat mit {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'Neuer Chat',
  'ai-mate.rovo-chat-header.rename-button-text': 'Umbenennen',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Umbenennen',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Seitenleiste',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Seitenleiste',
  'ai-mate.rovo-chat-header.switch-mode-button-label': 'Wechseln zu',
  'ai-mate.rovo-chat-header.switch-mode-section-text': 'Wechseln zu',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'Ein Projekt auswählen',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Senden',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Fragen Sie AI danach',
  'highlight-actions.rovo-chat-explain-option.text': 'Erklären',
  'highlight-actions.rovo-chat-explain-prompt':
    'Erkläre dies, indem du es umformulierst und zusätzliche Details hinzufügst. Verwende dabei sehr einfache Sprache und kurze Sätze und gib für Fachbegriffe aus dem Originaltext Beispiele oder eine Definition an.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Ressourcen finden',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Suchen Sie nur innerhalb des Unternehmenswissens nach Ressourcen, die die Aussagen unterstützen.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Nennen Sie Beispiele',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Nennen Sie Beispiele auf der Grundlage von Unternehmensressourcen oder öffentlich zugänglichem Wissen. Wenn keine Ressourcen zur Verfügung stehen, geben Sie ein metaphorisches Beispiel, das zum besseren Verständnis beitragen könnte.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Feedback geben',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Geben Sie Feedback, indem Sie die Ausdrucksweise überprüfen. Stellen Sie Kommentare zur Wortwahl, Grammatik und Zeichensetzung bereit. Seien immer positiv und motivierend, aber nennen Sie immer mindestens eine Sache, die verbessert oder geändert werden könnte.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatempfehlungen',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Chat öffnen',
  'highlight-actions.rovo-chat-summarize-option.text': 'Zusammenfassen',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Heben Sie die wichtigsten Punkte hervor. Konzentrieren Sie sich auf die wesentlichen Informationen und lassen Sie unwichtige Details aus. Geben Sie in einem einzelnen Absatz einen Überblick über den Inhalt wieder.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Im Chat fragen',
  'highlight-actions.rovo-chat.ask-rovo-button-text': 'Rovo fragen',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Hierzu eine Frage stellen',
  'horizontal-scroll-container.scroll-left': 'Nach links scrollen',
  'horizontal-scroll-container.scroll-right': 'Nach rechts scrollen',
  'rovo-chat.deep-research-spotlight.description':
    'Aktivieren Sie die Tiefenrecherche und geben Sie einen Prompt ein. Rovo erstellt dann einen Plan, führt die Recherche durch und generiert einen ausführlichen Bericht.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Schließen',
  'rovo-chat.deep-research-spotlight.heading': 'Neu: Tiefenrecherche in Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Kontext per Drag-and-Drop hinzufügen',
  'rovo-chat.message-file.icon-label': 'Datei',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': 'Lassen Sie uns ins Detail gehen',
  'rovo-chat.rovo-greeting.default-greeting-text': 'Wie kann ich Ihnen helfen, {name}?',
  'rovo-chat.search-input.screen-reader-prompt':
    'Wenn Sie eine Eingabe in diesem Feld vornehmen, werden die Suchergebnisse unten aktualisiert.',
};
